import RouteError from '@/components/layout/Page/RouteError.vue';
import RouteLoading from '@/components/layout/Page/RouteLoading.vue';

export default [
  {
    path: 'settings/my-user',
    name: 'userSettings',
    component: () => import(/* webpackChunkName: "settings-section" */ '@/components/pages/settings/UserSettings.vue'),
    meta: { title: 'My User' },
  },
  {
    path: 'settings/filters',
    name: 'manageFilters',
    component: () => import(/* webpackChunkName: "settings-section" */ '@/components/pages/settings/FiltersPage.vue'),
    meta: { title: 'Manage filters' },
  },
  {
    path: 'settings/kpis',
    name: 'manageKpis',
    component: () => import(/* webpackChunkName: "settings-section" */ '@/components/pages/settings/KpisPage.vue'),
    meta: { title: 'Manage KPIs' },
  },
  {
    path: 'settings/dashboards',
    name: 'manageDashboards',
    component: () => import(/* webpackChunkName: "settings-section" */ '@/components/pages/settings/DashboardsPage.vue'),
    meta: { title: 'Manage Dashboards' },
  },
  {
    path: 'settings/branding',
    name: 'branding',
    component: () => import(/* webpackChunkName: "settings-section" */ '@/components/pages/settings/BrandingPage.vue'),
    meta: { title: 'Branding' },
  },
  {
    path: 'settings/manage-users',
    name: 'manageUsers',
    component: () => import(/* webpackChunkName: "settings-section" */ '@/components/pages/settings/ManageUsers.vue'),
    meta: { title: 'Manage users' },
  },
  {
    path: 'settings/user/invite',
    name: 'inviteUser',
    component: () => import(/* webpackChunkName: "settings-section" */ '@/components/pages/settings/InviteUser.vue'),
    meta: { title: 'Edit user' },
  },
  {
    path: 'settings/properties',
    name: 'properties',
    component: () => import(/* webpackChunkName: "settings-section" */ '@/components/pages/settings/PropertiesPage.ts.vue'),
    meta: { title: 'Manage Properties' },
  },
  {
    path: 'settings/delete',
    name: 'delete',
    component: () => import(/* webpackChunkName: "settings-section" */ '@/components/pages/settings/DeleteAccount.vue'),
    meta: { title: 'Delete' },
  },
  {
    path: 'settings/tokens',
    name: 'tokens',
    component: () => import(/* webpackChunkName: "settings-section" */ '@/components/pages/settings/TokensPage.ts.vue'),
    meta: { title: 'Tokens' },
  },
  {
    path: 'settings/component-test',
    name: 'componentTest',
    component: () => import(/* webpackChunkName: "settings-section" */ '@/components/pages/settings/Test.vue'),
    meta: { title: 'Component test' },
  },
].map((route) => ({
  ...route,
  loading: RouteLoading,
  error: RouteError,
  delay: 200, // Delay before showing the loading component
  timeout: 5000, // The error component will be displayed if a timeout is provided and exceeded
  meta: {
    ...route.meta,
    section: 'Settings',
    highScale: true,
  },
}));
